import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';

const GaugeChart_BDT = (props) => {
    const { range_end, title, step_gap, apiEnd, range_start } = props.data
    const { packType, filterdata } = props
    const { isLoading, error, sendReq: fetchData } = useHttp();

    const [data, setValue] = useState({ value: 0, cellId: 0 })

    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
                body: { filterdata, packType },
            },
            (data) => {
                if (data[0]?.Max_Ohmic) {
                    setValue({ value: data[0]?.Max_Ohmic.value, cellId: data[0]?.key.Max_IR_Cell_ID })
                }
                if (data[0]?.Min_SOH) {
                    setValue({ value: data[0]?.Min_SOH.value, cellId: data[0]?.key.Min_SOH_Cell_ID })

                }
                if (!data.length) {
                    setValue({ value: 0, cellId: 0 })
                }
            }
        );
    }, [props]);

    const config = {
        scrollZoom: true,
        showLink: false,
        modeBarButtonsToRemove: ['toImage', 'zoom2d', 'pan', 'pan2d', 'autoScale2d'],
        displayLogo: false,
        displayModeBar: false
    };

    return (
        <>
            <Plot
                data={[
                    {
                        type: 'indicator',
                        mode: 'gauge+number',
                        value: data?.value,
                        // value: gauge_value,
                        title: {
                            text: title, font: { size: 12, color: '#0E3157', /* weight: "bold" */ }
                        },
                        gauge: {
                            axis: {
                                range: [range_start, range_end],
                                tickwidth: 1,
                                tickcolor: "#83a4cf",
                                tick0: 0,
                                dtick: step_gap,
                                tickfont: { size: 10, color: 'black' }
                            },
                            bar: { color: "#83a4cf" },
                            borderwidth: 1,
                            bordercolor: 'gray',
                            steps: [
                                { range: [range_start, range_end], color: "" },
                                { range: [range_start, data?.value], color: "#83a4cf" },
                                { range: [range_start, range_end], color: 'white' },

                            ],
                        }
                    }
                ]}
                layout={{
                    width: 270,
                    height: 195,
                    margin: { t: 25, b: 20, r: 50, l: 30 },
                    // annotations: [{
                    //     text: `Max of 208 cells, at cell Id = ${data?.cellId}`,
                    //     font: { size: 10, color: 'gray' },
                    //     showarrow: false,
                    //     x: 0.5,
                    //     y: 0.05
                    // }],
                }}
                config={config}
            />
        </>
    );
};

export default GaugeChart_BDT;
